import { getVariants } from "./allocation";
import { ExperimentConfig } from "./types/config";

export const experiments = {
  // CHECKOUT ------------------------------------------------------------------
  "abtest_dba_3494-dba_1": {
    description: "Delivery costs cart summary",
    variants: getVariants(["A-control", "B-shown"] as const),
    domain_and_index: "abtest_name_dba_1",
    formula: {
      gamma_nl: true,
      gamma_be: true,
      karwei_nl: true,
    },
  },
  "abtest_dba_3495-dba_2": {
    description: "Alternative text cart CTA",
    variants: getVariants(["A-control", "B-new"] as const),
    domain_and_index: "abtest_name_dba_2",
    formula: {
      gamma_nl: true,
      gamma_be: true,
      karwei_nl: true,
    },
  },
  "abtest_drl_3890-dba_4": {
    description: "Soft login wall mobile follow-up",
    variants: getVariants(["A-control", "B-login"] as const),
    domain_and_index: "abtest_name_dba_4",
    formula: {
      gamma_nl: true,
      gamma_be: true,
      karwei_nl: true,
    },
  },
  "abtest_server_side-dba_5": {
    description: "Server side A/B test",
    variants: getVariants(["A-control", "B-variant"] as const),
    domain_and_index: "abtest_name_dba_5",
    formula: {
      gamma_nl: true,
      gamma_be: true,
      karwei_nl: true,
    },
  },
  "abtest_dba_3474-dba_8": {
    description: "Rental damage waiver",
    variants: getVariants(["A-control", "B-info"] as const),
    domain_and_index: "abtest_name_dba_8",
    formula: {
      gamma_nl: true,
      gamma_be: true,
      karwei_nl: true,
    },
  },
  "abtest_dba_3399-dba_7": {
    description: "New header",
    variants: getVariants(["A-control", "B-new"] as const),
    domain_and_index: "abtest_name_dba_7",
    formula: {
      gamma_nl: true,
      gamma_be: true,
      karwei_nl: true,
    },
  },

  // MYACCOUNT -----------------------------------------------------------------
  "abtest_drl_3475-drl_3": {
    description: "Send login code on request",
    variants: getVariants(["A-control", "B-request"] as const),
    domain_and_index: "abtest_name_drl_3",
    formula: {
      gamma_nl: true,
      gamma_be: true,
      karwei_nl: true,
    },
  },

  // SHOPFRONT -----------------------------------------------------------------
  "abtest_ew_13052-ew_4": {
    description: "Search box placeholder",
    variants: getVariants([
      "A-control",
      "B-what-search",
      "C-search-and-diy",
    ] as const),
    domain_and_index: "abtest_name_ew_4",
    formula: {
      gamma_nl: true,
      gamma_be: false,
      karwei_nl: true,
    },
  },
} as const satisfies ExperimentConfig;
